import React, { Component } from "react";
import { connect } from "react-redux";
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";
import { setLocateSitesMarkerData } from "../../actions/locateSitesActions";
import LocateSiteInfoBox from "./locateSiteInfoBox";

class LocalSitesMap extends Component {
	state = {
		map: null,
        center: { lat: 20.5937, lng: 78.9629 },
        show_info_box : false
	};

	componentDidMount() {
		let map = this._map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
		this.setState({ map: map });
	}

	onMarkerClick = site_id => {
        this.props.setLocateSitesMarkerData(site_id);
    };
    
    onInfoBoxCloseClick = () => {
        this.setState({ show_info_box : false })
        this.props.setLocateSitesMarkerData(null);
    };

	render() {
		const { locate_site_site_array, locate_site_marker_data } = this.props;
        let { map, center, show_info_box } = this.state;
        let info_box_latitude, info_box_longitude;

        if(locate_site_marker_data._id){
            show_info_box = true;
            const { latitude, longitude } = locate_site_marker_data;
            info_box_latitude = latitude;
            info_box_longitude = longitude;
        }

		if (window.google && map && locate_site_site_array.length > 0) {
			let markerBounds = new window.google.maps.LatLngBounds();
			for (let i = 0; i < locate_site_site_array.length; i++) {
				let item = locate_site_site_array[i];
				let position = new window.google.maps.LatLng(
					parseFloat(item.latitude),
					parseFloat(item.longitude)
				);
				markerBounds.extend(position);
			}

			map.fitBounds(markerBounds);
        }
        
        let maps = window.google.maps;

		return (
			<GoogleMap defaultZoom={6} center={center} ref={map => (this._map = map)}>
				{locate_site_site_array.map((item, key) => {
                    const { latitude, longitude, _id } = item;
					let position = {
						lat: parseFloat(latitude),
						lng: parseFloat(longitude)
					};
					return (
						<Marker
							key={key}
							position={position}
							onClick={this.onMarkerClick.bind(this, _id)}
						/>
					);
				})}

				{show_info_box && (
                    <InfoBox
                        position={
                            new maps.LatLng(
                                parseFloat(info_box_latitude),
                                parseFloat(info_box_longitude)
                            )
                        }
                        options={{ enableEventPropagation: true }}
                        onCloseClick={this.onInfoBoxCloseClick.bind(this)}
                    >
                        <LocateSiteInfoBox set_marker_data={locate_site_marker_data} />
                    </InfoBox>
                )}
			</GoogleMap>
		);
	}
}

const mapStateToProps = state => {
	return {
		locate_site_site_array: state.locateSitesReducer.locate_site_site_array,
		locate_site_marker_data: state.locateSitesReducer.locate_site_marker_data
	};
};

export default connect(
	mapStateToProps,
	{ setLocateSitesMarkerData }
)(withGoogleMap(LocalSitesMap));



// WEBPACK FOOTER //
// ./src/v3/components/locateSites/localSitesMap.js